import React from "react";

import "./review-button.m.css";
import { REVIEW_TITLE } from "../../../constants";

const ReviewButton = () => {
  return (
    <div styleName="review-button" className="review-button">
      {REVIEW_TITLE}
    </div>
  );
};

export default ReviewButton;
